exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-068a69b3]{min-height:500px;background:#fff}.header-container[data-v-068a69b3]{font-family:artifaktElementBold}.modal-container-body[data-v-068a69b3]{background-color:#fff;padding:0 30px 30px 20px}.branch-description[data-v-068a69b3]{font-size:16px;font-family:artifaktElementRegular!important}", ""]);

// exports
